// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "3d14b07d7defb2f40cddc3c72aefa0cb39c37c35/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};